<ng-container *transloco="let t; prefix: scope">
  <form [formGroup]="form" class="tabbed-dialog-layout">
    <div class="tabbed-dialog-body">
      <div class="flex h-28">
        <div class="flex flex-col mr-1">
          <label for="span.start">{{ t('startDate') }}</label>
          <app-calendar
            [formControl]="form.controls.span.controls.start"
            [invalid]="form.controls.span.controls.start.errors?.start?.message"
            appendTo="body"
            inputId="span.start"></app-calendar>
        </div>
        <div class="flex flex-col ml-1">
          <label for="span.start">{{ t('endDate') }}</label>
          <app-calendar
            [formControl]="form.controls.span.controls.end"
            [invalid]="form.controls.span.controls.end.errors?.end?.message"
            appendTo="body"
            inputId="span.end"></app-calendar>
        </div>
      </div>
      <ng-container *appHideIfCountries="'NL'">
        <div class="h-24">
          <p class="font-semibold">{{ t('employerAndVatReturn') }}</p>
          <div class="flex ml-1">
            <p-checkbox [formControl]="form.controls.largeCompany" [binary]="true" inputId="largeCompany"></p-checkbox>
            <label for="largeCompany" class="mb-0 ml-4">{{ t('submissionLargeCompany') }}</label>
          </div>
        </div>
        <div class="h-24">
          <p class="font-semibold">{{ t('vatDeclaration') }}</p>
          <div class="flex justify-between">
            <div class="flex flex-1 ml-1">
              <p-checkbox
                [formControl]="form.controls.electronicVat"
                [binary]="true"
                inputId="electronicVat"></p-checkbox>
              <label for="electronicVat" class="mb-0 ml-4">{{ t('electronicVat') }}</label>
            </div>
            <div class="flex flex-1 ml-1">
              <p-checkbox [formControl]="form.controls.euCommerce" [binary]="true" inputId="euCommerce"></p-checkbox>
              <label for="euCommerce" class="mb-0 ml-4">{{ t('euCommerce') }}</label>
            </div>
          </div>
        </div>
        <div class="h-24">
          <p class="font-semibold">{{ t('periodicCompilation') }}</p>
          <div class="flex ml-1">
            <p-checkbox
              [formControl]="form.controls.electronicCompilation"
              [binary]="true"
              inputId="electronicCompilation"></p-checkbox>
            <label for="electronicCompilation" class="mb-0 ml-4">{{ t('electronicCompilation') }}</label>
          </div>
        </div>
        <div class="h-24">
          <p class="font-semibold">{{ t('incomeTaxReturn') }}</p>
          <div class="flex justify-between">
            <div class="flex flex-1 ml-1">
              <p-checkbox
                [formControl]="form.controls.firmTaxRespite"
                [binary]="true"
                inputId="firmTaxRespite"></p-checkbox>
              <label for="firmTaxRespite" class="mb-0 ml-4">{{ t('firmTaxRespite') }}</label>
            </div>
            <div class="flex flex-1 ml-1">
              <p-checkbox
                [formControl]="form.controls.electronicTax"
                [binary]="true"
                inputId="electronicTax"></p-checkbox>
              <label for="electronicTax" class="mb-0 ml-4">{{ t('electronicTax') }}</label>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div class="tabbed-dialog-actions flex justify-end items-end p-4 bg-bl-grey-100">
      <bl-frontend-button
        variant="secondary"
        (onclick)="close(null)"
        [text]="'shared.close' | transloco"></bl-frontend-button>
      <bl-frontend-button
        [disabled]="form.invalid"
        (onclick)="onSubmit()"
        [text]="'shared.save' | transloco"></bl-frontend-button>
    </div>
  </form>
</ng-container>
